import { notification } from 'antd';

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export const initializeFacebookSDK = () => {
  window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_DEVELOPERS_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v8.0'
      });
    };
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
};

export const getCurrentUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        const { latitude, longitude } = coords;
        resolve({
          lat: latitude,
          lng: longitude
        });
      });
    } else {
      notification.error({
        message: 'GET CURRENT LOCATION',
        description: 'getCurrentLocation feature is not supported by current Browser !'
      });
      reject('getCurrentLocation feature is not supported by current Browser !');
    }
  });
};